import type { WorkSection } from '../hooks/useCreateWorkForm';

/** Pictos des onglets de la modale épisode (Figma admin 323:5421), décoratifs. */
export const WorkSectionIcon: React.FC<{ section: WorkSection }> = ({ section }) => {
  const common = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    focusable: false,
    className: 'create-work-nav__icon',
  };

  switch (section) {
    case 'metadata':
      // Étiquette
      return (
        <svg {...common}>
          <path d="M3 12.6V4.5A1.5 1.5 0 0 1 4.5 3h8.1a1.5 1.5 0 0 1 1.06.44l6.9 6.9a1.5 1.5 0 0 1 0 2.12l-8.1 8.1a1.5 1.5 0 0 1-2.12 0l-6.9-6.9A1.5 1.5 0 0 1 3 12.6Z" />
          <circle cx="8" cy="8" r="1.5" />
        </svg>
      );
    case 'cover':
      // Image
      return (
        <svg {...common}>
          <rect x="3" y="3" width="18" height="18" rx="2.5" />
          <circle cx="9" cy="9" r="2" />
          <path d="m21 15-4.5-4.5L6 21" />
        </svg>
      );
    case 'audioDescription':
      // Pictogramme « AD »
      return (
        <svg {...common} viewBox="0 0 28 24" width={28}>
          <rect x="1" y="5" width="20" height="14" rx="3" fill="currentColor" stroke="none" />
          <text x="11" y="15.5" textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff" stroke="none" fontFamily="sans-serif">
            AD
          </text>
          <path d="M23 9.5a3.5 3.5 0 0 1 0 5M25.5 7.5a6.5 6.5 0 0 1 0 9" />
        </svg>
      );
    case 'audio':
      // Bulle de commentaire
      return (
        <svg {...common}>
          <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v9a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4h0A1.5 1.5 0 0 1 4 15.5Z" />
          <path d="M8.5 10h.01M12 10h.01M15.5 10h.01" strokeWidth={2.5} />
        </svg>
      );
  }
};
